import React from "react";
import cookie from "react-cookies";
import { Modal } from "react-bootstrap";
import InputMask from "react-input-mask";

import moment from "moment";
import "react-datepicker/dist/react-datepicker-cssmodules.css";

import { updateDriverLicense, uploadPaper } from "../../model/profile";
import { removeAccountPaper } from "../../model/car";

import { commonErr } from "../common/errors";
import ImageUpload from "../common/imageupload";
import { LoadingInline } from "../common/loading";
import { MessageBox } from "../common/messagebox";

import { CustomInputLabelOutside } from "../components/input";

import tip from "../../static/images/tip-dlicense.svg";

class UploadLicenseImage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			paper: {
				err: commonErr.INNIT,
			},
		};
	}
	componentDidMount() {
		const paper = {
			...this.state.paper,
			...this.props.paper,
		};
		this.setState({ paper });
		this.sendPhotos(paper);
	}

	sendPhotos = (paper) => {
		this.props.getPaperPhoto(paper);
	};

	hanldeFileInputChange = (photos) => {
		this.setState({
			paper: {
				...this.state.paper,
				err: commonErr.LOADING,
			},
		});

		uploadPaper(this.state.paper.id, photos[0]).then((resp) => {
			var photos = [];
			if (this.state.paper.photos) {
				photos = photos.concat(this.state.paper.photos);
			}
			if (resp.data.data && resp.data.data.id) {
				photos.push(resp.data.data);
			}

			const paper = {
				...this.state.paper,
				err: resp.data.error,
				errMsg: resp.data.errorMessage,
				photos: photos,
			};
			this.setState({
				paper,
			});
			this.sendPhotos(paper);
		});
	};

	hidePaperMessageBox = () => {
		this.setState({
			paper: {
				...this.state.paper,
				err: commonErr.INNIT,
				errMsg: "",
			},
		});
	};

	getPhotos = (paper) => {
		if (paper.photos) {
			return (
				<div className="photo fix-img" style={{ paddingBottom: "35%" }}>
					<img loading="lazy" src={paper.photos && paper.photos[paper.photos.length - 1].url} />
				</div>
			);
		}
	};

	render() {
		const { paper } = this.state;

		return (
			<>
				<div className="wrap-2-input-file">
					<div className="wrap-input">
						<div className="wrap-text">
							<label htmlFor="custom-file">
								{/* <div className="custom-action"> 
							
								<p className="text-underline">Chụp ảnh </p>
							</div> */}
								<div className="custom-action ">
									<div className="wrap-svg">
										<svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path
												d="M12 8C9.832 8 8 9.832 8 12C8 14.168 9.832 16 12 16C14.168 16 16 14.168 16 12C16 9.832 14.168 8 12 8ZM12 14C10.935 14 10 13.065 10 12C10 10.935 10.935 10 12 10C13.065 10 14 10.935 14 12C14 13.065 13.065 14 12 14Z"
												fill="#5FCF86"
											/>
											<path
												d="M20 5H17.414L14.707 2.293C14.6143 2.19996 14.5041 2.12617 14.3828 2.07589C14.2614 2.0256 14.1313 1.99981 14 2H10C9.86866 1.99981 9.73857 2.0256 9.61724 2.07589C9.4959 2.12617 9.38571 2.19996 9.293 2.293L6.586 5H4C2.897 5 2 5.897 2 7V18C2 19.103 2.897 20 4 20H20C21.103 20 22 19.103 22 18V7C22 5.897 21.103 5 20 5ZM4 18V7H7C7.266 7 7.52 6.895 7.707 6.707L10.414 4H13.586L16.293 6.707C16.3857 6.80004 16.4959 6.87383 16.6172 6.92412C16.7386 6.9744 16.8687 7.00019 17 7H20L20.002 18H4Z"
												fill="#5FCF86"
											/>
										</svg>
									</div>
									<p>Chọn ảnh</p>
								</div>

								<div className="custom-type">Mặt trước GPLX</div>

								{paper.err !== commonErr.LOADING ? (
									<ImageUpload withPreview={false} onChange={this.hanldeFileInputChange} />
								) : (
									<LoadingInline />
								)}

								<MessageBox
									show={paper.err < commonErr.SUCCESS}
									hideModal={this.hidePaperMessageBox}
									message={paper.errMsg}
								/>
							</label>
						</div>
					</div>

					{this.getPhotos(paper)}
				</div>

				{/* 
				<div className="list-photos">
					<label>{paper.name}</label>
					<p className="info">
						<i className="ic ic-infomation"></i>
						Hình chụp cần thấy được <span className="fontWeight-5">Ảnh đại diện</span> và <span className="fontWeight-5">Số GPLX</span></p>
					<ul>
						<li>
							<a className={`obj-photo`} style={{ backgroundImage: `url(${tip})` }}>
								<span className="ins">
									{paper.err !== commonErr.LOADING ? <ImageUpload withPreview={false} onChange={this.hanldeFileInputChange} className="form-control" /> : <LoadingInline />}
								
									<MessageBox show={paper.err < commonErr.SUCCESS} hideModal={this.hidePaperMessageBox} message={paper.errMsg} />
								</span>
							</a>
						</li>
						{this.getPhotos(paper)}
					</ul>
				</div> */}
			</>
		);
	}
}
class ChangeDriverLicense extends React.Component {
	constructor(props) {
		super(props);

		const { info } = props.profile;
		this.state = {
			step: 0, //0: show update 1: show update message 2: show confirm message
			err: commonErr.INNIT,
			errMsg: "",
			ip_licenseNumber: info && info.driverLicense.licenseNumber ? info.driverLicense.licenseNumber : "",
			ip_licenseName: info && info.driverLicense.licenseName ? info.driverLicense.licenseName : "",
			ip_dob:
				info && info.driverLicense.dob > 0
					? moment(info.driverLicense.dob).format("DD-MM-YYYY")
					: info.dob > 0
					? moment(info.dob).format("DD-MM-YYYY")
					: "01-01-1970",
			isLicenseNumberValid: true,
			isLicenseNameValid: true,
			isDoBValid: true,
			isPaperPhotosValid: true,
			alertMsg: "",
			paper: {},
		};
	}

	handleInputChange = (event) => {
		this.setState({
			[event.target.name]: event.target.value,
		});
	};

	callbackPaper = (paper) => {
		this.setState({ paper: paper });
	};

	refreshCheckFilled = () => {
		this.setState({
			isLicenseNumberValid: true,
			isLicenseNameValid: true,
			isDoBValid: true,
			isPaperPhotosValid: true,
			alertMsg: "",
		});
	};

	isValidSubmit = () => {
		const { ip_licenseNumber, ip_licenseName, ip_dob, paper } = this.state;

		this.refreshCheckFilled();

		if (ip_licenseNumber === "" || !ip_licenseNumber) {
			this.setState({
				isLicenseNumberValid: false,
				alertMsg: "Bạn chưa điền số GPLX",
			});
			return false;
		}

		if (ip_licenseName === "" || !ip_licenseName) {
			this.setState({
				isLicenseNameValid: false,
				alertMsg: "Bạn chưa điền họ tên",
			});
			return false;
		}

		if (ip_dob.includes("_") || !moment(`${ip_dob}`, "DD-MM-YYYY").isValid()) {
			this.setState({
				isDoBValid: false,
				alertMsg: "Ngày tháng năm sinh không hợp lệ",
			});
			return false;
		}

		if (!paper.photos || paper.photos === undefined) {
			this.setState({
				isPaperPhotosValid: false,
				alertMsg: "Bạn chưa cập nhật hình ảnh giấy phép lái xe",
			});
			return false;
		}

		return true;
	};

	onSubmitBtnClick = () => {
		const { ip_licenseNumber, ip_licenseName, ip_dob } = this.state;

		if (!this.isValidSubmit()) {
			this.setState({
				err: commonErr.FAIL,
			});
		} else {
			this.setState({
				step: 1,
				err: commonErr.LOADING,
			});

			const profile = {
				licenseNumber: ip_licenseNumber,
				licenseName: ip_licenseName,
				dob: moment(`${ip_dob}`, "DD-MM-YYYY").valueOf(),
			};

			updateDriverLicense(profile).then((resp) => {
				if (resp.data.error >= commonErr.SUCCESS) {
					this.setState({
						step: 1,
						err: resp.data.error,
						errMsg: resp.data.errorMessage,
						status: resp.data.data.driverLicenseStatus,
					});

					//GA
					const utmSrc = cookie.load("_utm_src") || "web_directly";
					const utmExt = cookie.load("_utm_ext") || "no_label";
					window.fbq("track", "VERIFY_DRIVER_LICENSE_SUCCESS");
					window.gtag('event', "VERIFY_DRIVER_LICENSE_SUCCESS", {
						event_category: utmSrc,
						event_label: utmExt,
						campaign: {source: utmSrc}
					});
				} else {
					this.setState({
						step: 1,
						err: resp.data.error,
						errMsg: resp.data.errorMessage,
					});
				}
			});
		}
	};

	onBackBtnClick = () => {
		this.props.getProfile();
		this.setState({
			step: 0,
			err: commonErr.INNIT,
			errMsg: "",
		});
	};

	closeForm = () => {
		this.setState({
			err: commonErr.INNIT,
			errMsg: "",
		});

		this.props.getProfile();
		this.props.hideModal();
	};

	onVerifyPhone = () => {
		this.props.showVerifyPhone();
		this.props.hideModal();
	};

	render() {
		var content;
		const {
			step,
			err,
			errMsg,
			status,
			ip_licenseNumber,
			ip_licenseName,
			ip_dob,
			alertMsg,
			isLicenseNameValid,
			isLicenseNumberValid,
			isDoBValid,
		} = this.state;

		if (step === 1) {
			if (err === commonErr.LOADING) {
				content = (
					<div className="modal-input-body">
						<LoadingInline />
					</div>
				);
			} else if (err >= commonErr.SUCCESS) {
				const profile = this.props.profile.info;
				switch (status) {
					case 1:
					case 3:
						content = (
							<div className="modal-input-body">
								<p className="font-14 text-success">Cập nhật thành công</p>
								<p className="font-14">Thông tin GPLX của bạn đã được xác thực thành công. Xin cảm ơn</p>
								{profile.phoneVerified !== 1 && (
									<>
										<p className="font-14">Bạn cần xác thực thêm Số điện thoại để có thể đặt xe</p>
										<div className="wrap-btn">
											<a className="btn btn-primary btn--m" onClick={this.onVerifyPhone}>
												Cập nhật ngay
											</a>
										</div>
									</>
								)}
							</div>
						);
						break;
					case 2:
						content = (
							<div className="modal-input-body">
								<p className="font-14 text-success">Cập nhật thành công</p>
								<p className="font-14">Thông tin GPLX của bạn sẽ được Mioto xác thực trong thời gian sớm nhất.</p>
								<p className="font-14">
									Lưu ý, bạn vẫn có thể tiến hành đặt xe trong thời gian chờ xác thực. Xin cảm ơn
								</p>
								{profile.phoneVerified !== 1 && (
									<>
										<p className="font-14">Bạn cần xác thực thêm Số điện thoại để có thể đặt xe</p>
										<div className="wrap-btn">
											<a className="btn btn-primary btn--m" onClick={this.onVerifyPhone}>
												Cập nhật ngay
											</a>
										</div>
									</>
								)}
							</div>
						);
						break;
					case 11:
						content = (
							<div className="modal-input-body">
								<p className="font-14 text-danger">Cập nhật thất bại</p>
								<p className="font-14">
									Mioto không tìm thấy thông tin GPLX của bạn trên hệ thống. Bạn vui lòng kiểm tra lại{" "}
									<span className="fontWeight-5">Số GPLX</span>, <span className="fontWeight-5">Ngày sinh</span> và tiến
									hành cập nhật lại.
								</p>
								<p className="font-14">
									Nếu vẫn không thể xác thực, vui lòng liên hệ Mioto để được hỗ trợ nhanh nhất. (Tổng đài 19009217 -
									9:00AM - 6:00PM T2-T7 hoặc gửi tin nhắn đến Mioto Fanpage)
								</p>
								<p className="font-14">
									Lưu ý: GPLX mới cấp trong vòng 30 ngày có thể chưa được cập nhật trên hệ thống GPLX trực tuyến.
								</p>
								<div className="wrap-btn">
									<a className="btn btn-primary btn--m" onClick={this.onBackBtnClick}>
										Thử lại
									</a>
								</div>
							</div>
						);
						break;
				}
			} else {
				content = (
					<div className="modal-input-body">
						<p className="font-14 text-danger">Cập nhật thất bại. {errMsg}</p>
						<div className="wrap-btn">
							<a className="btn btn-primary btn--m" onClick={this.onBackBtnClick}>
								Thử lại
							</a>
						</div>
					</div>
				);
			}
		} else {
			if (this.props.profile && this.props.profile.info) {
				const { papers } = this.props.profile.info.driverLicense;

				content = (
					<div className="modal-input-body modal-driving-license-body">
						{alertMsg !== "" && (
							<div className="message-valid-box">
								<p className="text-danger">{alertMsg}</p>
							</div>
						)}
						<div className="line-form">
							<CustomInputLabelOutside
								placeholder={"Nhập số GPLX đã cấp"}
								type={"text"}
								name={"ip_licenseNumber"}
								label={"Số giấy phép lái xe"}
								value={ip_licenseNumber}
								onChange={this.handleInputChange}
								valid={isLicenseNumberValid ? "success" : "error"}
								status={alertMsg}
							/>
						</div>
						<div className="line-form">
							<CustomInputLabelOutside
								placeholder={"Nhập đầy đủ họ tên"}
								type={"text"}
								name={"ip_licenseName"}
								label={"Họ và tên"}
								value={ip_licenseName}
								onChange={this.handleInputChange}
								valid={isLicenseNameValid ? "success" : "error"}
							/>
						</div>
						<div className="line-form">
							<div className="custom-input">
								<div className="wrap-info">
									<div className="title-status">
										<p>Ngày sinh</p>
									</div>
								</div>
								<div className="wrap-input">
									<div className="wrap-text">
										<InputMask
											name="ip_dob"
											mask="99-99-9999"
											defaultValue={`${this.state.ip_dob}`}
											onChange={this.handleInputChange}
										/>
									</div>
								</div>
							</div>
						</div>
						<div className="line-form">
							<div className="custom-input">
								<div className="wrap-info">
									<div className="title-status">
										<p>Ảnh giấy phép lái xe</p>
									</div>
								</div>

								{papers.map((paper, i) => (
									<UploadLicenseImage key={i} paper={paper} getPaperPhoto={this.callbackPaper} />
								))}
							</div>
						</div>

						<div className="wrap-btn btn-register">
							<a className="btn btn--m btn-primary" onClick={this.onSubmitBtnClick}>
								Cập nhật
							</a>
						</div>
					</div>
				);
			}
		}

		return (
			<Modal show={this.props.show} onHide={this.closeForm} dialogClassName="modal-s modal-input">
				<Modal.Header closeButton={true} closeLabel={""}>
					<h5>Xác thực giấy phép lái xe</h5>
				</Modal.Header>
				<Modal.Body>{content}</Modal.Body>
			</Modal>
		);
	}
}

export default ChangeDriverLicense;
